// extracted by mini-css-extract-plugin
export default {"root":"styles_root__wfp2n","icon":"styles_icon__xkb--","label":"styles_label__GddGL"};